import { Component, Input, OnInit, ViewEncapsulation, computed, signal } from '@angular/core';
import { Router } from '@angular/router';

import { RoutingHelperService } from '../../../core/services/routingHelper/routing-helper.service';
import { BetFilterParamsService } from '../../../retail/services/betFilterParams/bet-filter-params.service';
import { CouponsDetailsService } from '../couponsDetails/coupons-details.service';
import { ICoupon, ICouponsConfig } from '../couponsListSportTab/coupons.model';
import { COUPONS, MATCHES } from './coupons-list.constant';
import { ICouponSegment } from './coupons-list.model';
import { CouponsListService } from './coupons-list.service';

@Component({
    selector: 'coupons-list',
    styleUrls: ['./coupons-list.component.scss'],
    templateUrl: './coupons-list.component.html',
    // eslint-disable-next-line
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class CouponsListComponent implements OnInit {
    @Input() couponsList: ICoupon[];
    @Input() enableGaTracking: boolean;
    @Input() isCoral: boolean;
    @Input() isSportTab: boolean;

    readonly couponSegments = signal<ICouponSegment[]>([]);
    readonly couponSegmentsWithCoupons = computed(() => this.couponSegments().filter((x) => x.coupons!.length > 0));
    readonly couponSegmentsCount = computed(() => this.couponSegmentsWithCoupons().reduce((acc, x) => acc + x.coupons!.length, 0));

    constructor(
        private betFilterParamsService: BetFilterParamsService,
        private couponsListService: CouponsListService,
        private routingHelperService: RoutingHelperService,
        private router: Router,
        private couponsDetailsService: CouponsDetailsService,
    ) {}

    ngOnInit(): void {
        if (this.couponsList?.length) {
            this.couponsListService.getCouponSegment().subscribe(
                (segments: ICouponSegment[]) => {
                    this.couponSegments.set(this.couponsListService.groupCouponBySegment(this.couponsList, segments));
                },
                () => {
                    this.couponSegments.set(this.couponsListService.groupCouponBySegment(this.couponsList, []));
                },
            );
        }
    }

    /**
     * ngFor trackBy function
     * @param {number} index
     * @param {ICoupon} coupon
     * @return {string}
     */
    trackById(index: number, coupon: ICoupon): string {
        return coupon?.id ? `${index}${coupon.id}` : index.toString();
    }

    /**
     * couponUrl()
     * @param {ICoupon} coupon
     * @returns {string}
     */
    couponUrl(coupon: ICoupon): string {
        const datedCoupons = (this.couponsListService.getCouponsConfigValue(COUPONS.DATE_COUPONS as keyof ICouponsConfig)() as string).split(',');
        const isinclusionCoupon = this.couponsListService.containsValue(COUPONS.MARKET_INCLUSION as keyof ICouponsConfig, coupon.id);
        const isExclusionCoupon = this.couponsListService.containsValue(COUPONS.MARKET_UNIQUE_IDS as keyof ICouponsConfig, coupon.id);
        const redirectCouponId = isinclusionCoupon && !isExclusionCoupon ? datedCoupons[0] : coupon.id;
        const redirectCouponName = isinclusionCoupon && !isExclusionCoupon ? MATCHES.TODAY : coupon.name;
        const couponName = this.routingHelperService.encodeUrlPart(redirectCouponName);
        return `/coupons/football/${couponName}/${redirectCouponId}`;
    }

    onClick(event: ICoupon, navigate: boolean = false) {
        const cmConfig = this.couponsListService.cmConfigSignal();
        const defaultSelectMarket =
            typeof cmConfig === 'object' && cmConfig !== null && event.id in cmConfig ? (cmConfig as Record<string, string>)[event.id] : '';
        this.couponsListService.setStoreDefault(event, defaultSelectMarket);
        if (this.enableGaTracking) {
            this.couponsDetailsService.pushToGTM(event.name);
        }

        if (navigate) {
            this.router.navigateByUrl(this.couponUrl(event));
        }
    }

    /**
     * goToBetFilter()
     */
    goToBetFilter(): void {
        this.betFilterParamsService.chooseMode().subscribe((betFilterParams) => {
            if (!betFilterParams.cancelled) {
                this.router.navigate(['bet-filter', 'filters', 'your-teams']);
            }
        });
    }
}
